<template>
    <div>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="box box-default box-solid">
                        <div class="box-body table-responsive">
                            <form v-if="newUserBatchListVisible">
                                <div class="form-group required-field col-md-6"
                                    :class="[{ 'has-error': vErrors.first('unitIds'), 'has-success': !vErrors.first('unitIds') && unitSelectHasBeenChanged }]">
                                    <label>Jednostki:</label>
                                    <select v-validate="{ rules: { required: true } }" name="unitIds"
                                        class="form-control" multiple data-vv-value-path="value" data-vv-as="unit"
                                        @change="multiselectValues($event.target.selectedOptions)"
                                        >
                                        <option v-for="option in units" :value="option.id" :key="option.id">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group required-field col-md-6"
                                    :class="[{ 'has-error': vErrors.first('contractorId'), 'has-success': !vErrors.first('contractorId') && contractorSelectHasBeenChanged }]">
                                    <label>Kontrahent:</label>
                                    <select v-validate="{ rules: { required: true } }" name="contractorId"
                                        class="form-control" data-vv-value-path="value" data-vv-as="contractor"
                                        @change="selectValue($event.target.selectedOptions)"
                                        >
                                        <option :value="0" :key="0">
                                            wybierz
                                        </option>
                                        <option v-for="option in contractors" :value="option.id" :key="option.id">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-12">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th class="table-light--label">Imię</th>
                                                <th class="table-light--label">Nazwisko</th>
                                                <th class="table-light--label">E-mail</th>
                                                <th class="table-light--label">Telefon</th>
                                                <th class="table-light--desc">Status</th>
                                                <th class="table-light--desc">Dodaj</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(user) in this.model.users">
                                                <tr :key="user['email']">
                                                    <td>{{ user['forename'] }}</td>
                                                    <td>{{ user['surname'] }}</td>
                                                    <td>{{ user['email'] }}</td>
                                                    <td>{{ user['phone'] }}</td>
                                                    <td>{{ (user['status'] === "new") ? 'nowy' : (user['status'] === "active") ? 'aktywny' : 'nieaktywny' }}</td>
                                                    <td>
                                                        <input v-if="user['status'] === 'new'"
                                                            :id="`active-${user['email']}`" 
                                                            :data-email="user['email']"
                                                            :data-firstname="user['forename']" 
                                                            :data-lastname="user['surname']"
                                                            :data-phone="user['phone']" 
                                                            :checked="user['checked']"
                                                            :disabled="user['status'] !== 'new'"
                                                            :hidden="user['status'] !== 'new'"
                                                            :data-active="user['status']" type="checkbox"
                                                            @change="toggleUsers(user['email'])">
                                                        <label :for="`active-${user['email']}`"></label>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <template>
                                    <div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="box box-default box-solid box-component">
                                                    <div class="box-body">
                                                        <table class="user-role-edit-table table-light">
                                                            <thead>
                                                                <tr>
                                                                    <th class="table-light--label ">
                                                                        Klient
                                                                    </th>
                                                                    <th class="table-light--label">
                                                                        Rola
                                                                    </th>
                                                                    <th class="table-light--desc">
                                                                        Opis
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="app in apps">
                                                                    <tr v-for="(userRole, roleIndex) in roles[app.name]"
                                                                        :key="`${app.name}_${roleIndex}`"
                                                                        :class="{ 'major-tr': roleIndex === 0 }">
                                                                        <td v-if="roleIndex === 0"
                                                                            :rowspan="roles[app.name].length">
                                                                            {{ app.label }}
                                                                        </td>
                                                                        <td>
                                                                            <div class="user-role-edit-checkbox">
                                                                                <input
                                                                                    :id="`${app.name}_${userRole.name}`"
                                                                                    v-model="rolesModel[app.name]"
                                                                                    type="checkbox"
                                                                                    :value="userRole.name"
                                                                                    @change="rolesValue($event, roleIndex)">
                                                                                <label
                                                                                    :for="`${app.name}_${userRole.name}`">{{
                                                                                        userRole.label
                                                                                    }}{{ userRole.businessRole ?' (rola biznesowa)' : '' }}</label>
                                                                            </div>
                                                                        </td>
                                                                        <td>{{ userRole.description }}</td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </form>
                            <div v-else-if="Object.values(this.summaryModel).length > 0" class="col-sm-12">
                                <h3>Importuj użytkowników - podsumowanie</h3>
                                <div>
                                    <span><b>Jednostki: </b></span>
                                    <template v-for="unit in summaryModel.unitIds">
                                        <span :key="unit">{{ units.find((element) => element.id == unit).label }},
                                        </span>
                                    </template>
                                </div>
                                <div>
                                    <span><b>Kontrahent: </b>{{ summaryModel.contractorName }}</span>
                                </div>
                                <div>
                                    <span><b>Role:</b> </span>
                                    <template>
                                        <div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="box box-default box-solid box-component">
                                                        <div class="box-body">
                                                            <table class="user-role-edit-table table-light">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="table-light--label ">
                                                                            Klient
                                                                        </th>
                                                                        <th class="table-light--label">
                                                                            Rola
                                                                        </th>
                                                                        <th class="table-light--desc">
                                                                            Opis
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <template v-for="(rolesList, appName) in summaryModel.roles">
                                                                        <tr v-for="(roleName, roleIndex) in rolesList"
                                                                            :class="{ 'major-tr': appName === 0 }"
                                                                            :key="`${appName}_${roleIndex}`">
                                                                            <td v-if="roleIndex == 0"
                                                                                :rowspan="rolesList.length">
                                                                                {{ appName }}
                                                                            </td>
                                                                            <td>{{ roleName }}</td>
                                                                            <td>{{ roleName }}</td>
                                                                        </tr>
                                                                    </template>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div>
                                    <span><b>Użytkownicy:</b> </span>
                                    <template>
                                        <div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="box box-default box-solid box-component">
                                                        <div class="box-body">
                                                            <table class="user-role-edit-table table-light">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="table-light--label ">
                                                                            Imię
                                                                        </th>
                                                                        <th class="table-light--label">
                                                                            Nazwisko
                                                                        </th>
                                                                        <th class="table-light--desc">
                                                                            E-mail
                                                                        </th>
                                                                        <th class="table-light--desc">
                                                                            Telefon
                                                                        </th>
                                                                        <th class="table-light--desc">
                                                                            Status
                                                                        </th>
                                                                        <th class="table-light--desc">
                                                                            Dodany
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <template>
                                                                        <tr v-for="(user, userIndex) in summaryModel.users"
                                                                            :key="`neUser_${userIndex}`">
                                                                            <td>{{ user['forename'] }}</td>
                                                                            <td>{{ user['surname'] }}</td>
                                                                            <td>{{ user['email'] }}</td>
                                                                            <td>{{ user['phone'] }}</td>
                                                                            <td>{{ (user['status'] === "new") ? 'nowy' : (user['status'] === "active") ? 'aktywny' : 'nieaktywny' }}</td>
                                                                            <td>{{ user['checked'] ? 'tak' : 'nie' }}</td>
                                                                        </tr>
                                                                    </template>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div v-else class="col-sm-12">
                                <h3>Importuj użytkowników - ekran startowy</h3>
                                <h4>Wybierz i zaimportuj plik xlsx z danymi użytkowników w dolnym menu</h4>
                                <p>Plik musi zawierać następujące kolumny:<br>
                                    imię, nazwisko, e-mail, telefon (w wierszu nr 1, ważna jest wielkość znaków)<br>
                                    <br>
                                    Wartości w kolumnie e-mail muszą być unikalne. Te dane służą do wykrywania, czy użytkownik już istnieje w systemie.<br>
                                    Wartości w kolumnie telefon jako jedyne mogą być puste.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <new-user-batch :show="newUserBatchModalVisible" @close="newUserBatchModalVisible = false" />
    </div>
</template>

<script>
import api from '../../../../../api'
import NewUserBatch from './modal/NewUserBatch';
import Page from '../../../../share/content/Page'
import Webstorage from '../../../../share/WebStorage'

export default {
    components: {
        NewUserBatch
    },
    mixins: [
        Page
    ],
    data() {
        return {
            events: {
                addUserBatch: "core:user:addUserBatch",
                addUserBatchSave: 'core:user:addUserBatchSave'
            },
            newUserBatchListVisible: false,
            newUserBatchModalVisible: false,
            unitSelectHasBeenChanged: false,
            units: [],
            roles: {},
            rolesModel: [],
            contractorSelectHasBeenChanged: false,
            model: {
                contractorId: null,
                contractorName: "",
                roles: {},
                unitIds: [],
                users: {},
            },
            summaryModel: {}
        }
    },
    mounted() {
        this.toggleLoading()
        this.$root.$on('importData', (o) => {
            this.model.users = o;
            this.newUserBatchModalVisible = false;
            this.newUserBatchListVisible = true;
        })
        this.getApps()
        this.loadUnits()
        this.loadContractors()
        this.loadRoles(),
        this.toggleLoading()

        this.$events.on(this.events.addUserBatch, this.addUserBatch);
        this.$events.on(this.events.addUserBatchSave, this.addUserBatchSave)
    },
    methods: {
        getEvents() {
            this.events = {
                addUserBatchSave: `core:user:addUserBatchSave`
            }
        },
        errorNotify(msg) {
            this.$notify({
                type: 'error',
                text: msg
            })
        },
        toggleUsers(key) {
            this.model.users[key].checked = !this.model.users[key].checked
        },
        validateContractor() {
            if (this.model.contractorId === undefined || this.model.contractorId === null) {
                this.errorNotify('Brak wybranego kontrahenta');

                return false;
            }

            return true;
        },
        validateRoles() {
            if (this.model.roles === undefined || Object.values(this.model.roles).length === 0) {
                this.errorNotify('Brak wybranych ról użytkownika');

                return false;
            }

            return true;
        },
        validateUnits() {
            if (this.model.unitIds === undefined || Object.values(this.model.unitIds).length === 0) {
                this.errorNotify('Brak wybranych jednostek');

                return false;
            }

            return true;
        },
        validateUsers() {
            if (this.model.users === undefined || Object.values(this.model.users).length === 0) {
                this.errorNotify('Brak użytkowników do zaimportowania');

                return false;
            }

            return true;
        },
        addUserBatchSave() {
            this.toggleLoading()
            if (
                this.validateUsers() &&
                this.validateContractor() &&
                this.validateUnits() &&
                this.validateRoles()
            ) {
            Object.entries(this.model.users).forEach(async ([key, newUser]) => {
                if(newUser['checked'] === true) {
                    await api.request('core', 'post', 'users', this.createDataToSend(newUser['forename'], newUser['surname'], newUser['email'], newUser['phone']))
                        .then((response) => {
                            this.$notify({
                                type: 'success',
                                text: 'Dodano użytkownika' + response.data.uuid
                            })
                            for (let c = 0; c < this.apps.length; c++) {
                                let appName = this.apps[c].name
                                api.request(appName, 'put', `/users/${response.data.uuid}/roles`, this.rolesModel[appName])
                                    .then((response) => {
                                        this.$notify({
                                            type: 'success',
                                            text: 'Przypisane role użytkownikowi'
                                        })
                                    })
                                    .catch((error) => {
                                        this.errorNotify(error);
                                    })
                            }
                        })
                        .catch((error) => {
                            this.errorNotify(error);
                        })
                }
            });

            this.prepareSummary()
            }

            this.toggleLoading()
        },
        prepareSummary() {
            this.summaryModel = this.model
            this.model = {}
            this.newUserBatchListVisible = false
        },
        createDataToSend(forename, surname, email, phone) {
            return {
                forename: forename,
                surname: surname,
                phone: phone ? phone.toString() : '',
                email: email,
                units: this.model.unitIds,
                contractor: this.model.contractorId,
                description: ""
            }
        },
        addUserBatch() {
            this.newUserBatchModalVisible = true;
        },
        selectValue(selectedOptions) {
            this.model.contractorId = selectedOptions[0].value
            this.model.contractorName = selectedOptions[0].label
            this.contractorSelectHasBeenChanged = true
        },
        multiselectValues(selectedUnits) {
            this.model.unitIds = []
            let units = [...selectedUnits]
            units.forEach((unit) => {
                this.model.unitIds.push(unit.value)
            })
            this.unitSelectHasBeenChanged = true
        },
        loadUnits() {
            api.request('core', 'get', '/units')
                .then((response) => {
                    this.units = response.data
                })
                .catch((error) => {
                    this.errorNotify(error);
                })
        },
        getApps() {
            this.apps = Object.entries(Webstorage.getContractorApps()).map((value, index) => {
                return {
                    id: index,
                    name: value[0],
                    label: value[1]
                }
            })
        },
        loadContractors() {
            api.request('core', 'get', '/contractors')
                .then((response) => {
                    const sortAlphaNum = (a, b) => a.label.localeCompare(b.label, 'pl', { numeric: true })
                    this.contractors = response.data.sort(sortAlphaNum)
                })
                .catch((error) => {
                    this.errorNotify(error);
                })
        },
        rolesValue(event, index) {
            let id = event.target.id
            let appName = id.substr(0, id.indexOf('_'))

            if (this.model.roles === undefined) {
                this.model.roles = []
                this.model.roles[appName] = [event.target.value]
            } else {
                if (this.model.roles[appName] === undefined) {
                    this.model.roles[appName] = [event.target.value]
                } else {
                    const found = this.model.roles[appName].findIndex((x) => x === event.target.value);

                    if (found === -1) {
                        this.model.roles[appName].push(event.target.value)
                    } else {
                        if (event.target.checked === false) {
                            this.model.roles[appName].splice(found, 1)
                        }
                    }
                }
            }
        },
        loadRoles() {
            for (let c = 0; c < this.apps.length; c++) {
                this.rolesModel[this.apps[c].name] = []
            }

            for (let c = 0; c < this.apps.length; c++) {
                var appname1 = this.apps[c].name
                api.request(appname1, 'get', `/roles`)
                    .then((response) => {
                        let appName = this.apps[c].name
                        this.roles[appName] = response.data
                    })
                    .catch((error) => {
                        this.errorNotify(error);
                    })
            }
        },
    }
}
</script>
